import { create } from 'zustand';
import { CMDIDropdownRBDMItem } from '@services/hooks/endusers/cmdiDropdownRBDM';

interface CMDIDropdownStore {
	cmdiDropdownData: CMDIDropdownRBDMItem[] | null;
	isLoading: boolean;
	error: Error | null;
	updateCMDIDropdownData: (data: CMDIDropdownRBDMItem[] | null) => void;
	updateLoadingState: (isLoading: boolean) => void;
	updateError: (error: Error | null) => void;
	clearCMDIDropdownData: () => void;
}

const initialState = {
	cmdiDropdownData: null,
	isLoading: false,
	error: null,
};

export const useCMDIDropdownStore = create<CMDIDropdownStore>((set) => ({
	...initialState,
	updateCMDIDropdownData: (data: CMDIDropdownRBDMItem[] | null): void => set(() => ({ cmdiDropdownData: data })),
	updateLoadingState: (isLoading: boolean): void => set(() => ({ isLoading })),
	updateError: (error: Error | null): void => set(() => ({ error })),
	clearCMDIDropdownData: (): void =>
		set(() => ({
			cmdiDropdownData: null,
			isLoading: false,
			error: null,
		})),
}));
